// extracted by mini-css-extract-plugin
export default {"empty-sidepanel":"EmptySidePanel_empty-sidepanel__EBBGv","main-text":"EmptySidePanel_main-text__0w4F5"};